export default __webpack_public_path__ + "static/media/webscraping.fb0f71d8.png";